module.exports = __webpack_public_path__ + "static/media/notificatios-icon.73c00c91.svg";